<template>
  <div
    v-if="visible"
    class="downloadGuide"
  >
    <div
      class="downloadGuide__panel"
      @click.stop
    >
      <hr class="downloadGuide__line" />
      <img
        class="downloadGuide__panel_close global_pointer"
        @click="close"
        :src="require('@/assets/imgs/close.png')"
      />

      <div class="downloadGuide__content">
        <div class="downloadGuide__title">
          {{ $t('message.downloadGuide.title') }}
        </div>

        <div class="downloadGuide__desc">
          {{ $t('message.downloadGuide.desc1') }}
          <span> $25 </span>
          {{ $t('message.downloadGuide.desc2') }}
        </div>


        <template v-if="isIOS">
          <div class="downloadGuide__download_desc">
            {{ $t('message.downloadGuide.downloadDesc') }}
          </div>

          <img
            class="downloadGuide__hand"
            src="@/assets/imgs/hand.png"
          />

          <div
            class="downloadGuide__form_item downloadGuide__form_item-button global_pointer"
            @click="download"
          >
            {{ $t('message.downloadGuide.download') }}
          </div>
        </template>
        <template v-else>
          <div style="height: 45px"></div>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
import OpenApp from "@/common/openApp";
const openApp = new OpenApp();
import { plateForm } from "@/utils"
export default {
  name: "downloadGuide",
  data() {
    return {
      visible: false,
      complete: null,
      isIOS: plateForm().isIOS
    };
  },
  methods: {
    download() {
      openApp.download();

      this.visible = false;
      this.complete ? this.complete() : null;
    },
    close() {
      this.visible = false;
      this.complete ? this.complete() : null;
    },
    open(input = {}) {
      let { bindComplete } = input;
      this.visible = true;

      this.complete = bindComplete;
    },
  },
};
</script>


<style lang="less" scoped>
  .downloadGuide {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    &__hand {
      width: 14px;
      height: 21px;
      margin-top: 27px;
    }
    &__panel {
      position: absolute;
      width: 100%;
      background: #ffffff;
      left: 0;
      bottom: 0;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      overflow: hidden;
      z-index: 110;
      &_close {
        width: 26px;
        height: 26px;
        position: absolute;
        right: 12px;
        top: 12px;
      }
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__line {
      border: 0;
      padding: 0;
      margin: 0;
      width: 100%;
      height: 8px;
      background: #c0ddde;
    }
    &__title {
      margin-top: 28px;
      font-size: 24px;
      font-family: "TradeGothicNextLTPro-Hv";
      color: #000000;
      font-weight: bold;
    }
    &__desc {
      margin-top: 20px;
      font-size: 16px;
      color: #000;
      font-family: "TradeGothicLT";
      & span {
        font-size: 18px;
        color: #39d2d6;
        font-family: "TradeGothicLT-Bold";
      }
    }
    &__download_desc {
      margin-top: 10px;
      font-size: 18px;
      color: #000;
      font-family: "TradeGothicLT-Bold";
    }

    &__form_item {
      background: #f5f5f5;
      border-radius: 18px;
      border: 1px solid #f2f2f2;
      width: 243px;
      height: 36px;
      line-height: 36px;
      margin: 10px auto 44px;
      box-sizing: border-box;
      text-align: left;
      padding: 0 11px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    &__form_item-button {
      border: 0;
      background: #000000;
      border-radius: 22px;
      text-align: center;
      font-size: 16px;
      font-family: "TradeGothicLT";
      color: #ffffff;
      justify-content: center;
    }
  }
</style>